import BaseModelAPI from '../BaseModelAPI';

export default class ContractDocumentList extends BaseModelAPI {

	static entity = 'contractdocumentlist'
	static entityName = 'contractdocument';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
